var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modalCreateCalculationProductionAddWorkersAll",
        title: "Показывать в таблице должности",
        centered: "",
        "hide-footer": "",
        "hide-header": "",
      },
      on: {
        show: _vm.onShowModal,
        close: function ($event) {
          _vm.localActive = false
        },
      },
      model: {
        value: _vm.localActive,
        callback: function ($$v) {
          _vm.localActive = $$v
        },
        expression: "localActive",
      },
    },
    [
      _c(
        "div",
        { staticClass: "m-add-workers-all" },
        [
          _c(
            "svg",
            {
              staticClass: "m-add-workers-all-close",
              attrs: {
                width: "15",
                height: "16",
                viewBox: "0 0 15 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
              on: {
                click: function ($event) {
                  _vm.localActive = false
                },
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                  fill: "#8E9CBB",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                  fill: "#8E9CBB",
                },
              }),
            ]
          ),
          _c("div", { staticClass: "m-add-workers-all-title" }, [
            _vm._v("Добавить сотрудников"),
          ]),
          _c("c-tabs", {
            ref: "tabs",
            staticClass: "m-add-workers-all-tabs",
            staticStyle: { visibility: "hidden" },
            attrs: {
              id: "tabsAddWorkersAll",
              active: _vm.activeTab,
              items: _vm.tabs.items,
            },
            on: { change: _vm.changeTab },
          }),
          _c(
            "div",
            { staticClass: "m-add-workers-all-search" },
            [
              _c("c-switcher", {
                staticClass: "m-add-workers-all-search-switcher",
                attrs: { label: "Все филиалы" },
                model: {
                  value: _vm.isShowWorkersAllFilials,
                  callback: function ($$v) {
                    _vm.isShowWorkersAllFilials = $$v
                  },
                  expression: "isShowWorkersAllFilials",
                },
              }),
              _c("c-input", {
                staticClass: "m-add-workers-all-search-input",
                attrs: {
                  placeholder: "Поиск по ФИО",
                  icon: "search",
                  "placeholder-style": "italic",
                  clearable: "",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "position-relative" }, [
            _c("div", {
              staticClass: "m-add-workers-all-content-shadow-top",
              attrs: { id: "m-add-workers-all-content-shadow-top" },
            }),
            _c(
              "div",
              {
                staticClass: "m-add-workers-all-content",
                attrs: { id: "m-add-workers-all-content" },
                on: { scroll: _vm.setShadowsOnScroll },
              },
              [
                _c(
                  "div",
                  { staticClass: "m-add-workers-all-content-result" },
                  [
                    _vm._l(_vm.workersLocal, function (worker, i) {
                      return [
                        worker.isVisible &&
                        ((!_vm.isShowWorkersAllFilials && worker.is_filial) ||
                          _vm.isShowWorkersAllFilials)
                          ? _c("c-switcher", {
                              key: `worker-${worker.id}-${i}`,
                              staticClass:
                                "m-add-workers-all-content-result-item",
                              attrs: {
                                type: "checkbox",
                                label: worker.name,
                                "sub-label": `${worker.filial_name}, ${worker.post}`,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeWorkerActive(worker)
                                },
                              },
                              model: {
                                value: worker.isActive,
                                callback: function ($$v) {
                                  _vm.$set(worker, "isActive", $$v)
                                },
                                expression: "worker.isActive",
                              },
                            })
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                ),
                !_vm.workersLocal.some(
                  (worker) =>
                    worker.isVisible &&
                    ((!_vm.isShowWorkersAllFilials && worker.is_filial) ||
                      _vm.isShowWorkersAllFilials)
                )
                  ? _c(
                      "div",
                      { staticClass: "m-add-workers-all-content-empty" },
                      [_vm._v(" Сотрудники не найдены ")]
                    )
                  : _vm._e(),
              ]
            ),
            _c("div", {
              staticClass: "m-add-workers-all-content-shadow-bottom",
              attrs: { id: "m-add-workers-all-content-shadow-bottom" },
            }),
          ]),
          _c(
            "div",
            { staticClass: "m-add-workers-all-actions" },
            [
              _c("c-button", {
                staticClass: "m-add-workers-all-actions-reset",
                attrs: { size: "large", label: "Сбросить" },
                on: {
                  click: function ($event) {
                    return _vm.reset()
                  },
                },
              }),
              _c("c-button", {
                staticClass: "m-add-workers-all-actions-apply",
                attrs: { label: "Применить", color: "blue", size: "large" },
                on: {
                  click: function ($event) {
                    return _vm.submitWorkers()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }